module.exports = __webpack_public_path__ + "static/media/icon_page_wrong.9cd302f0.svg";